import { useState } from 'react';

import type { UseComplianceModalReturn } from './types';

// Owns the open/close state of the State Compliance Modal so MixApplyPage
// stays under the 100-line cap. Callers wire open() to the "Generate Report"
// button and pass isOpen + close to the modal.
const useComplianceModal = (): UseComplianceModalReturn => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);

    return { close, isOpen, open };
};

export default useComplianceModal;
